/** Возвращает обязательное значение build-time окружения. */
const getRequiredEnv = (name: keyof ImportMetaEnv): string => {
  const value = import.meta.env[name];

  if (!value) {
    throw new Error(`Missing required env variable: ${String(name)}`);
  }

  return value;
};

/** Публичное identity микрофронтенда для host registry и runtime config. */
export const MF_NAME = getRequiredEnv('VITE_MF_NAME');
